import { SVGProps } from "react"
const XIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 6L6 18M18 18L6 6"
      stroke={props.color || "black"}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
export default XIcon
